import React, { useState } from 'react';
import { Backdrop, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useAuth } from '../../providers/authentication';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import AddIcon from '../../assets/images/add.png';

function Login() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const token = searchParams.get('token');

  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const handleEnterToSearch = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key == 'Enter') {
      handleOnClickSignIn();
    }
  };
  const handleOnClickSignIn = () => {
    if (username && password && !isLoading) {
      setIsLoading(true);
      auth?.signIn(username, password).finally(() => setIsLoading(false));
    }
  };

  const handleAzureLogin = () => {
    if (!isLoading) {
      setIsLoading(true);
      auth
        ?.signInWithAD()
        .catch((e) => {
          console.error(e);
        })
        .finally(() => setIsLoading(false));
    }
  };

  if (token && !auth?.error) {
    if (!isLoading) {
      setIsLoading(true);
      auth?.signInWithToken(token).finally(() => {
        // searchParams.delete('token');
        setIsLoading(false);
      });
    }
  }

  if (auth?.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#ACCEF7',
        backgroundSize: 'cover',
        background: "url('/asset/3180954.jpg') center"
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: 400,
          width: 300,
          minHeight: 300,
          backgroundColor: '#fff',
          background:
            'radial-gradient(circle, rgb(255, 255, 255) 40%, rgba(255, 255, 255, 0) 100%)',
          borderRadius: 20,
          padding: 30
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img src={'/asset/SHIP-03.png'} alt="Logo" width={200} />
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { m: 1, width: '25ch' }
            }}
            noValidate
            display={'block'}
            autoComplete="off"
            style={{ marginTop: 10 }}
          >
            <div>
              <TextField
                label="Username"
                autoComplete="current-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div>
              <TextField
                label="Password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleEnterToSearch}
                required
              />
            </div>
          </Box>
          <Typography
            // variant="subtitle2"
            gutterBottom
            sx={{
              fontSize: '0.875rem',
              lineHeight: 1.2,
              width: '22ch',
              color: 'red',
              textAlign: 'center'
            }}
          >
            {auth?.error}
          </Typography>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0px 20px'
          }}
        >
          <Button variant="contained" color="primary" onClick={handleOnClickSignIn}>
            Login
          </Button>
          &nbsp;
          <Button variant="contained" color="warning" onClick={handleAzureLogin}>
            เข้าสู่ระบบด้วย PTT AD
          </Button>
          &nbsp;
          <a style={{ textDecoration: 'none' }} href={"https://usapor.pttplc.com?token=" + searchParams.get('token')}>
            <Button variant="contained" color="success">
              <img style={{ width: 20, marginRight: 8, filter: 'invert(1)' }} src={AddIcon} />
              SHIP Portal
            </Button>
          </a>
        </div>
      </div>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default Login;
